export {ControlLabel} from './ControlLabel';
export type {Size as ControlLabelSize, Props as ControlLabelProps} from './types';
